import { render } from "./doacoes.vue?vue&type=template&id=a42c4470&ts=true"
import script from "./doacoes.vue?vue&type=script&lang=ts"
export * from "./doacoes.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__